import React from 'react';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import { PortalNames } from "common/Portals";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import { ReactComponent as LogIQmindIcon } from 'assets/img/LogIQmindIcon.svg';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { SvgIcon } from '@mui/material';

export const SidebarData = [
    {
        title: "Dashboard",
        icon: <DashboardOutlinedIcon />,
        link: `/${PortalNames.CollectionPartner.Path}/dashboard`,
    },
    {
        title: "Appearance",
        icon: <PaletteOutlinedIcon />,
        link: `/${PortalNames.CollectionPartner.Path}/appearance`,
    },
    {
        title: "LogIQmind Manager",
        icon: <SvgIcon>
                <LogIQmindIcon />
            </SvgIcon>,
        link: `/${PortalNames.CollectionPartner.Path}/logiqmind-manager`
    },
    {
        title: "Accounting",
        icon: <PaymentsOutlinedIcon />,
        link: `/${PortalNames.CollectionPartner.Path}/accounting`,
    },
    {
        title: "Contract Management",
        icon: <WorkOutlineOutlinedIcon />,
        link: `/${PortalNames.CollectionPartner.Path}/contracts`
    },
    {
        title: "Email Templates",
        icon: <EmailOutlinedIcon />,
        link: `/${PortalNames.CollectionPartner.Path}/template`
    },
    {
        title: "Compliance Management",
        icon: <VerifiedUserOutlinedIcon />,
        link: `/${PortalNames.CollectionPartner.Path}/compliance`
    },
    {
        title: "Uploads",
        icon: <DescriptionOutlinedIcon />,
        link: `/${PortalNames.CollectionPartner.Path}/uploads`
    },
]
